/**
 * Cuándo pasó, en la esquina derecha de cada fila de la campanita.
 *
 * Estaba escrito suelto en cada ítem y ya había divergido: dos filas lo
 * mostraban en mono y la de procesos en proporcional, así que la columna de
 * tiempos no alineaba entre secciones. Es el rol de «número tabular» que el
 * sistema sanciona para mono, definido UNA vez y consumido por nombre.
 */
import { formatRelative } from './formatRelative';

export function TiempoRelativo({ iso }: { iso: string | null | undefined }) {
  if (!iso) return null;
  return (
    <time className="text-fg-dim shrink-0 font-mono text-micro" dateTime={iso}>
      {formatRelative(iso)}
    </time>
  );
}
